// react and mui stuff
import { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';
import { UserContext } from './utils/contexts';
import Toast, { ToastContext } from './components/toast';

import Button from '@mui/joy/Button';

import Login from '@mui/icons-material/Login';

// custom components
import { MetaProps } from './components/metaprops';
import { Header } from './components/templates/layout';
import Loading from './components/loading';

// styles
import { CssVarsProvider } from '@mui/joy/styles';
import CssBaseline from '@mui/joy/CssBaseline';
import "./styles/common.css"

// routes
import LandingPage from './routes/landing';
import Wallpapers from './routes/wallpapers';
import IndexRoutes from './routes';
import DaedalusIndex from './routes/houses';

// data and stuff
import { userAPI } from './utils/backend';
import { CliUser } from './types/users';
import { failure, unauth } from './utils/setdata';
import ErrorPage from './routes/error';
import { debuglog } from './utils/utils';


export default function App() {
  const [toast, setToast] = useState<{ text: string, color?: "primary" | "neutral" | "danger" | "success" | "warning" }>()
  const [user, setUser] = useState<CliUser | null>();
  const [loading, setLoading] = useState<boolean>(true);
  useEffect(() => {
    if (user) return;
    // see if user is logged in
    userAPI.auth().then(a => {
      debuglog("AUTH", a)
      // if not, show em the loading screen
      if (unauth(a, user, setToast)) return setLoading(false);
      // if it somehow failed, don't load anything else
      if (failure(a, setToast)) return;
      setUser(a)
      setLoading(false)
      // get the cliuser. commented out due to fetching parts at a time
      // userAPI.getMain(a.id).then(usr => {
      //   // check if unauth (in the rare event that their session expired in the nanoseconds between calculations)
      //   if (unauth(usr, setToast)) return setUser(undefined)
      //   // check if there was a failure
      //   else if (!failure(usr, setToast)) {
      //     setUser(usr.user)
      //     setLoading(false)
      //   }
      // })
    })
  }, [user])

  // loading screen!
  if (loading) return (
    <CssVarsProvider disableTransitionOnChange>
      <ToastContext.Provider value={{ toast, setToast }}>
        <Toast/>
        <CssBaseline />
        <div style={{ height: "100vh" }}>
          <Loading/>
        </div>
      </ToastContext.Provider>
    </CssVarsProvider>
  )
  // landing screen!
  if (!user) return (
    <CssVarsProvider disableTransitionOnChange>
      <ToastContext.Provider value={{ toast, setToast }}>
        <Toast/>
        <CssBaseline />
        <BrowserRouter>
          <Routes>
            <Route path="wallpapers" element={<WallpaperScreen/>}/>
            <Route path="error" element={<ErrorPage/>}/>
            <Route path='*' element={<LandingPage/>}/>
          </Routes>
        </BrowserRouter>
      </ToastContext.Provider>
    </CssVarsProvider>
  )
  return (
    <UserContext.Provider value={{ user: user, setUser: setUser}}>
      <ToastContext.Provider value={{ toast, setToast }}>
        <Toast/>
        <BrowserRouter>
          <Routes>
            <Route path='/daedalus3/*' element={<DaedalusIndex/>}/>
            <Route path='/*' element={<IndexRoutes/>} />
          </Routes>
        </BrowserRouter>
      </ToastContext.Provider>
    </UserContext.Provider>
  );
}

function WallpaperScreen() {
  const nav = useNavigate();
  const [toast, setToast] = useState<{ text: string, color?: "primary" | "neutral" | "danger" | "success" | "warning" }>()
  return (
    <CssVarsProvider disableTransitionOnChange>
      <ToastContext.Provider value={{ toast, setToast }}>
          <Toast/>
        <CssBaseline />
        <MetaProps path={window.location.pathname}/>
        <Header>
          <Button
              size="sm"
              variant="outlined"
              color="neutral"
              sx={{ alignSelf: 'center' }}
              startDecorator={<Login/>}
              onClick={() => nav("../")}
            >
              Back to login
            </Button>
        </Header>
        <Wallpapers/>
      </ToastContext.Provider>
    </CssVarsProvider>
  )
}